module.exports = __webpack_public_path__ + "img/pic_zht@2x(1).66c55b1b.png";